import * as Diagram from "../../../../components/diagram";
import { generateSerialArray } from "../../../common";
import moment from "moment";

export const ElderlyHealthStatisticsReport = {
  label: "老人健康統計報表",
  key: "ElderlyHealthStatisticsReport",
  path: "ElderlyHealth/ElderlyHealthStatisticsReport",
  api: "TCS_V_ElderlyHealthCareVisitMonthlyReport",
  render: (options) => (
    <Diagram.ElderlyHealth.ElderlyHealthStatisticsReport {...options} />
  ),
  isRaw: true,
  isPage: true,
  page: null,
  isColSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "RegionName",
      field: "RegionName",
      header: "",
    },
    {
      key: "VillageName",
      field: "VillageName",
      header: "",
    },
  ],
  filterMainKey: "ElderlyHealthSame",
  filterColumns: [
    {
      key: "noback_year",
      label: "年份",
      type: "singleDropdown",
      options: generateSerialArray(2023, Number(moment().format("YYYY"))).map(
        (item) => ({ label: item, value: item })
      ),
    },
  ],
  columns: [
    {
      key: "inVillage",
      field: "inVillage_format",
      header: "65歲以上\n在籍人數",
    },
    {
      key: "controlCount",
      field: "controlCount_format",
      header: "去年已健康評估",
    },
    {
      key: "controlVisitCount",
      field: "controlVisitCount_format",
      header: "當年已健康評估",
    },
    {
      key: "inAgency",
      field: "inAgency_format",
      header: "入住機構",
    },
    {
      key: "dead",
      field: "dead_format",
      header: "死亡",
    },
    {
      key: "level",
      field: "level_format",
      header: "列管等級",
      // isControl: true,
      // isSum: true,
      child: [
        {
          key: "level1",
          field: "level1_format",
          header: "健康",
        },
        {
          key: "level4",
          field: "level4_format",
          header: "亞健康",
        },
        {
          key: "level2",
          field: "level2_format",
          header: "衰弱",
        },
        {
          key: "level3",
          field: "level3_format",
          header: "失能",
        },
      ],
    },
  ],
};
